export const REDUX_SET = '/redux/container/RentalReservationContainer/set';
export const REDUX_RESET = '/redux/container/RentalReservationContainer/reset';
